import * as HttpService from "../../../../service/HttpService";
/**
 * 获取用能房屋列表
 */
export const getRoomEnergyCareInfo = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/agEnergyCare/getRoomEnergyCareInfo",data);
};
/**
 * 获取能耗排名（人均能耗、面积能耗）
 */
export const getEnergyCostRanked = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/agEnergyCostIndex/getEnergyCostRanked",data);
};

/**
 * 获取设备告警详情
 */
export const getSoeRecordDetails = (id) => {
    return HttpService.get(HttpService.DOMAIN + "/agEnergyCare/getSoeRecordDetails?roomId="+id);
};

/**
 * 获取曲线
 */

export const getHistoricalCurve = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/realTimeMonitoring/getHistoricalCurve",data);
};

/**
 * 获取当月曲线
 */
